import { useEffect, useState, useRef } from "react";
import { Card, Table, Tooltip, Space, } from "antd";
import IconButton from "components/ui/Button/IconButton";
import { useNavigate } from 'react-router-dom';
import { convertToReadableFormat } from "components/common/validation";
import { removeLastComma } from "utils/StringUtils";
import { ImagePaths } from "utils/ImagePath";
import ConfigurationFilter from "../ConfigurationFilter";
import CommonTblHeader from "components/common/CommonTblHeader";
import ToastMsg from "components/common/ToastMsg";
import useApiData from "components/common/useGetApiData";
import { getSalaryDeduction } from "hooks/api/configurationApi/salaryDeduction";
import { SALARY_DEDUCTION } from "constants";
import {checkUserPermissionFunc, deleteDraftItemsById} from "components/common/CommonFuntion";
import { CommonDeletePopup } from 'components/common/CommonComponent';

const initialData = {
  deduction_code: "",
  deduction_name: "",
  share: "",
  deduct_from: "",
  deduction_is_active: "",
}

const SalaryDeductions = () => {
  let query = "";
  let queryRef = useRef("");
  const pageSize = 10;
  const authtoken = sessionStorage.getItem("token")

  const [editVisible, setEditVisible] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [sorting, setSorting] = useState("");
  const [dataToBeUpdated, setDataToBeUpdated] = useState({});
  const [dataUpdated, setDataUpdated] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterDatas, setFilterDatas] = useState({ initialData });
  const [reorderedColumns, setReorderedColumns] = useState([]);
  const [isDraft, setIsDraft] = useState(false);
  const [deleteItem, setDeleteClicked] = useState({ id: undefined, isDeleteClicked: false });
  const tableContainerHeight = isDraft ? "77.5vh" : "72vh";

  const navigate = useNavigate();

  useEffect(() => {
    if (!authtoken) {
      window.location.href = '/';
    }
  }, [authtoken]);

  const userPermission = checkUserPermissionFunc("configuration", "Salary Deduction", "SubMenu");

  const [data, pageInfo, loading, _message, refetch] = useApiData(getSalaryDeduction, {
    pageNo,
    pageSize,
    query,
    searchText,
    sorting
  });

  useEffect(() => {
    if (_message && _message.isErrorMsg && _message.errorMsgText) {
      ToastMsg('error', _message.errorMsgText);
    }
  }, [_message, _message.errorMsgText]);

  const addClick = () => {
    setEditVisible(false);
    setDataToBeUpdated({});
    navigate('/configuration/salarydeductions/add', { state: { fromEdit: false, editDetails: {}, isActive: userPermission?.active !== undefined ? userPermission?.active : true } });
  };

  const handleEditClick = (salaryDeductionData) => {
    setDataToBeUpdated(salaryDeductionData);
    if (editVisible && Object.keys(dataToBeUpdated).length > 0) {
      ToastMsg("warning", "Please cancel the existing edit operation!")
    }
    else if (!editVisible) {
      setEditVisible(true);
      navigate('/configuration/salarydeductions/add', { state: { fromEdit: true, editDetails: salaryDeductionData, isActive: userPermission?.active !== undefined ? userPermission?.active : true } });
      setDataToBeUpdated(salaryDeductionData);
    }
  };

  const handleSearch = () => {
    setEditVisible(false)
    setDataToBeUpdated({});
    setPageNo(1);
    refetch(1,
      pageSize,
      query,
      searchText,
      sorting);
    setDataUpdated(!dataUpdated);
  }

  const handleTableChange = (pagination, filters, sorter) => {
    const sortorder = `sort=${sorter.order === "descend" ? "desc" : sorter.order === "ascend" ? "asc" : ""}&`
    const sortQuery = sorter.order ? `${sortorder}column=${sorter.columnKey}` : ""
    queryRef.current = isDraft ? `is_draft=True` : "";
    refetch(pagination.current,
      pageSize,
      queryRef.current,
      searchText,
      sortQuery);
    setSorting(sortQuery)
  }

  // filter start
  const renderFilter = (data) => {
    setFilterDatas((prevdata) => ({ ...prevdata, ...data }));
    setPageNo(1);
    refetch(1,
      pageSize,
      `code=${data.deduction_code ? data.deduction_code : ""}&deduction_name=${data.deduction_name ? data.deduction_name : ""}&share=${data.share ? data.share : ""}&deduct_from=${data.deduct_from ? data.deduct_from : ""}&is_active=${data.deduction_is_active !== undefined ? data.deduction_is_active : ""}`,
      searchText,
      sorting);
    setFilterVisible(false);
  }

  const ClosePopUp = () => {
    setFilterVisible(false);
  }

  const clearFilter = () => {
    setFilterDatas(initialData);
    setPageNo(1);
    refetch(1,
      pageSize,
      query,
      searchText,
      sorting);
  }
  //filter end

  const columns = [
    {
      title: "Deduction Code",
      dataIndex: "code",
      key: "code",
      sorter: true,
      width: "14.28%",
      fixed: "left",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (record.code?.length > 20 ?
          <Tooltip title={record.code}>{<span style={{ color: colors }}>{record.code?.slice(0, 20) + "..."}</span>}</Tooltip>
          : <p style={{ color: colors }}>{record.code ? record.code : "-"}</p>)
      }
    },
    {
      title: "Deduction Name",
      dataIndex: "deduction_name",
      key: "deduction_name",
      sorter: true,
      width: "17.96%",
      fixed: "left",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (record.deduction_name?.length > 20 ?
          <Tooltip title={record.deduction_name}>{<span style={{ color: colors }}>{record.deduction_name?.slice(0, 20) + "..."}</span>}</Tooltip>
          : <p style={{ color: colors }}>{record.deduction_name ? record.deduction_name : "-"}</p>)
      }
    },
    {
      title: "Share ",
      dataIndex: "share",
      key: "share",
      sorter: true,
      width: "14.28%",
      fixed: "left",
      render: (_, record) => {
        let colors = record?.is_active ? "black" : "#CACACA";
        return (record.share?.length > 20 ?
          <Tooltip title={record.share}>{<span style={{ color: colors }}>{record.share?.slice(0, 20) + "..."}</span>}</Tooltip>
          : <p style={{ color: colors }}>{record.share ? record.share : "-"}</p>)
      }
    },
    {
      title: "Deduct From",
      dataIndex: "deduct_from",
      key: "deduct_from",
      sorter: true,
      width: "14.28%",
      fixed: "left",
      render: (_, record) => (<span style={{ color: record.is_active === true ? "black" : "#CACACA" }}>
        {record.deduct_from ? removeLastComma(record.deduct_from.map((dpt) => convertToReadableFormat(dpt))) : "-"}
      </span>),
    },
    {
      title: "Notes",
      dataIndex: "notes",
      key: "notes",
      sorter: true,
      width: "17.88%",
      fixed: "left",
      render: (_, record) =>
      (record?.notes?.length > 28 ?
        <Tooltip title={record?.notes}>{<span style={{ color: record?.is_active ? "black" : "#CACACA" }}>{record?.notes?.slice(0, 25) + "..."}</span>}</Tooltip>
        : <p style={{ color: record?.is_active ? "black" : "#CACACA" }}>{record?.notes ? record?.notes : "-"}</p>)
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      sorter: true,
      width: "12.28%",
      fixed: "left",
      render: (_, record) =>
        record.is_active === true ? (
          <span style={{ color: "black" }}>Active</span>
        ) : (
          <span style={{ color: "#CACACA" }}>Inactive</span>
        ),
      align: 'center',
    },
  ];
  if (userPermission?.edit) {
    columns.push({
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "9%",
      align: 'center',
      fixed: "left",
      render: (_, record) => (
        <div className="flex justify-center items-center">
          <Space size={"middle"}>
            <IconButton
              title="Edit"
              icon={<img src={ImagePaths.edit.default} alt="Edit" />}
              onClick={() => (loading ? "" : handleEditClick(record))}
              testID={'ug_btn_edit'}
            />
            {record.is_draft === true ?
              <IconButton
                title="Delete"
                icon={<img src={ImagePaths.delete.default} alt="Delete" />}
                onClick={() => (loading ? "" : handleDeleteClicked(record?.id))}
                testID={'ug_btn_delete'}
              /> : null}
          </Space>
        </div>
      ),
    })
  }

  //draft delete start
  const handleDeleteClicked = (id) => {
    setDeleteClicked((prevdata) => ({
      ...prevdata,
      id: id,
      isDeleteClicked: true
    }));
  }

  const handleCancelBtn = () => {
    setDeleteClicked((prevdata) => ({
      ...prevdata,
      id: undefined,
      isDeleteClicked: false
    }));
  }

  const handleDeleteBtn = async (id) => {
    try {
      const apiData = await deleteDraftItemsById(id, SALARY_DEDUCTION);
      if (apiData && apiData.status === "success") {
        ToastMsg("success", apiData.message);
        handleDraft();
      } else {
        ToastMsg("error", apiData.message);
      }
    } catch (error) {
      ToastMsg("error", error.message);
    } finally {
      handleCancelBtn();
    }
  }//draft delete end

  const handleFilter = () => {
    setFilterVisible(true)
  }

  const handleDraft = () => {
    setIsDraft(true);
    setFilterVisible(false);
    setSorting("");
    setPageNo(1);
    queryRef.current = `is_draft=True`
    refetch(pageNo,
      pageSize,
      queryRef.current,
      searchText,
      "");
  }

  const handleBackToHome = () => {
    setIsDraft(false);
    setSorting("");
    setPageNo(1);
    queryRef.current = "";
    refetch(1,
      pageSize,
      queryRef.current,
      searchText,
      "");
  }

  const handleStateChanges = (search = "", reorderedList = []) => {
    setSearchText(search)
    setReorderedColumns(reorderedList)
  }

  const queryString =
    "?page_no=" + pageNo +
    "&page_size=" + pageSize +
    "&code=" + (filterDatas.deduction_code ? filterDatas.deduction_code : "") +
    "&deduction_name=" + (filterDatas.deduction_name ? filterDatas.deduction_name : "") +
    "&share=" + (filterDatas.share ? filterDatas.share : "") +
    "&deduct_from=" + (filterDatas.deduct_from ? filterDatas.deduct_from : "") +
    "&is_active=" + (filterDatas.deduction_is_active !== undefined ? filterDatas.deduction_is_active : "") +
    "&search=" + searchText + (sorting ? `&${sorting}` : "");
    
  const styles = {
    fltContainer: {
      border: "1px solid #cbcbcb",
      height: tableContainerHeight,
    },
  }

  return (
    <Card className="h-full overflow-hidden">
      <div className={"h-1/6"} >
        <CommonTblHeader pageName={"Salary Deduction"}
          pageInfo={pageInfo}
          handleSearch={handleSearch} selectedDetails={dataToBeUpdated} addClick={addClick}
          onStateChange={handleStateChanges} handleFilter={handleFilter} columns={columns}
          handleDraft={handleDraft} isDraft={isDraft} handleBackToHome={handleBackToHome}
          url={SALARY_DEDUCTION} query={queryString}
          isAddRequired = {userPermission?.add ? true : false}
          isDraftRequired = {userPermission?.draft ? true : false}
          testID={'sd'}
        />
      </div>
      <div className="h-5/6 flex justify-center items-center  mt-1">
        {filterVisible ?
          <div className="w-1/4 mt-5" style={styles.fltContainer}>
            <ConfigurationFilter
              pageName={"SalaryDeduction"}
              filterDatas={filterDatas}
              closeFilter={ClosePopUp}
              filteredData={renderFilter}
              clearData={clearFilter} />
          </div>
          : null}
        <div className={filterVisible ? "mt-5 w-3/4" : "mt-5 w-full"} style={styles.fltContainer}>
        <Table 
          columns={reorderedColumns?.length > 0 ? reorderedColumns : columns}
          dataSource={data?.length > 0 ? data : null}
          loading={loading}
          style = {{"--table-container-height": tableContainerHeight}}
          scroll={{ y: `calc(${tableContainerHeight} - 140px)` }}
          onChange={handleTableChange}
          pagination={{
            style: { marginRight: 20, padding: 0 },
            defaultPageSize: pageSize,
            showSizeChanger: false,
            showQuickJumper: true,
            total: pageInfo?.totalCount ? pageInfo?.totalCount : 0,
            pageSizeOptions: ["10", "20", "30"],
            pageSize,
            defaultCurrent: pageNo,
          }}
          key={isDraft ? (dataUpdated ? "draftUpdated" : "draftNotUpdated") : (dataUpdated ? "updated" : "not-updated")}
        />
        </div>
      </div>
      {deleteItem.isDeleteClicked ? <CommonDeletePopup handleCancelBtn={handleCancelBtn} handleDeleteBtn={() => handleDeleteBtn(deleteItem.id)} /> : null}
    </Card>
  );
};

export default SalaryDeductions;
